// The icons named in navigation/modules.js.
import {
    BarChart3, Building2, Calendar, CalendarCheck, CalendarDays, CalendarRange, CheckSquare, Clock, FileStack, FileText,
    FolderKanban, IndianRupee, ListChecks, Network, Receipt, ReceiptText, ScrollText, Settings, SlidersHorizontal, Timer,
    Users, Wallet, Workflow,
} from 'lucide-react';

export const ICONS = {
    BarChart3, Building2, Calendar, CalendarCheck, CalendarDays, CalendarRange, CheckSquare, Clock, FileStack, FileText,
    FolderKanban, IndianRupee, ListChecks, Network, Receipt, ReceiptText, ScrollText, Settings, SlidersHorizontal, Timer,
    Users, Wallet, Workflow,
};

export const iconFor = (name) => ICONS[name] || FileText;
